import {Stack, styled} from '@mui/material';
import {IconIllustration} from 'presentation/components';

export const StyledStack = styled(Stack)(({theme}) => ({
	position: 'relative',
	paddingLeft: 16,
	'&::before': {
		content: '""',
		position: 'absolute',
		left: 0,
		top: 0,
		bottom: 0,
		width: 4,
		backgroundColor: theme.palette.other.verticalBarColor,
		borderRadius: 16,
	},
}));

export const StyledIconIllustration = styled(IconIllustration)`
	background-color: ${({theme}) => theme.palette.other.inversedColorIconBg};
`;
